// import { DollarSign } from "lucide-react";
// import { Link } from "react-router-dom";

// export default function FinancialButtons() {
//   return (
//     <>
//       <div className="flex flex-col space-y-1 hidden sm:block">
//           <button>
//         <Link to={"/deposit"} className="flex items-center justify-center space-x-1 p-1.5 px-3.5 w-28 bg-green-700 text-white rounded-md text-xs hover:bg-green-700 transition-colors duration-300">
//           {" "}
//             <DollarSign size={15} />
//             <span>Deposit</span>
//         </Link>
//           </button>
//           <button>
//         <Link to={"/withdraw"} className="flex items-center justify-center space-x-1 w-28 bg-primary text-white p-1.5 px-3.5 rounded-md text-xs hover:bg-primary transition-colors duration-300">
//           {" "}
//             <DollarSign size={15} />
//             <span>Withdrawal</span>
//         </Link>
//           </button>
//       </div>
//     </>
//   );
// }

import React from "react"
import { BadgeIndianRupee } from "lucide-react"
import { Link } from "react-router-dom"

export default function FinancialButtons() {
  return (
    <div className="flex flex-col justify-center items-center font-=semibold space-y-1 sm:block hidden">
      <Link
        to="/deposit"
        className="flex items-center justify-center space-x-1 p-1.5 px-3.5 w-28 bg-green-700 text-white rounded-md text-xs hover:bg-green-600 transition-colors duration-300"
      >
        <BadgeIndianRupee size={15} />
        <span>Deposit</span>
      </Link>
      <Link
        to="/withdraw"
        className="flex items-center justify-center space-x-1 w-28 bg-red-500 text-white p-1.5 px-3.5 rounded-md text-xs hover:bg-blue-600 transition-colors duration-300"
      >
        <BadgeIndianRupee size={15} />
        <span>Withdrawal</span>
      </Link>
    </div>
  )
}